<template>

    <span class="mangelCarousel" v-if="images && images.length > 0">

        <b-carousel data-interval="false"
                    ref="myCarousel"
                    id="carousel-fade"
                    fade
                    :indicators="indicators"
                    :interval="0"
                    @sliding-end="onSlideEnd"
                    :controls="controls">

            <b-carousel-slide
                v-for="image in images"
                class="align-middle"
                :key="image.id">
              <template #img>
                <div class="d-flex justify-content-center align-items-center min-vh-100">
                  <img
                      class="d-block img-fluid"
                      @click="showLarge(image)"
                      :src="mangelImageUrl(image.url)"
                      alt=""
                      style="cursor: pointer">
                </div>
              </template>
              <div style="text-shadow: 1px 1px rgba(0, 0, 0, 1);color:#e9ecef">

                <b-alert variant="success" show v-if="image.status == 'ABGESCHLOSSEN'" style="background-color: #73b02585">
                  {{ $t('message.maengelTable_abgeschlossen_status') }}
                </b-alert>
                <b-alert variant="success" show v-if="image.status == 'ERLEDIGT'" style="background-color: #73b02585">
                  {{ $t('message.maengelTable_erledigt') }}
                </b-alert>
                <span v-if="image.datum">
                  {{ $t('message.imageCarousel_aufgenommen_am') }}:
                  <java-date-to-default-date-format v-model="image.datum" />
                </span>
                <br v-if="image.datum && image.email" />
                <span v-if="image.email">
                  {{ $t('message.imageCarousel_aufgenommen_von') }}:
                  {{ image.email }}
                </span>
                <!-- löschen -->
                <b-button
                    v-if="$store.getters.user_role.authority == ROLE_KEY_USER || $store.getters.user_role.authority == ROLE_ADMIN"
                    variant="danger"
                    size="sm"
                    class="float-right"
                    @click="deleteImage(image)"
                    style="font-size: 0.6rem;opacity: 0.6">
                  <b-icon icon="trash"></b-icon>
                </b-button>

              </div>
            </b-carousel-slide>

        </b-carousel>

        <b-modal id="large-img" :title="$t('message.imageCarousel_detailansicht')" size="xl">

          <span v-if="image">
            <img class="w-100" :src="mangelImageUrl(image.url)" />
          </span>

          <template #modal-footer v-if="$store.getters.user_role.authority == ROLE_KEY_USER || $store.getters.user_role.authority == ROLE_ADMIN">
            <div class="w-100">
              <b-button
                  variant="danger"
                  size="sm"
                  class="float-right"
                  @click="deleteImage(image)">
                <b-icon icon="trash"></b-icon>&nbsp;{{ $t("message.default_loeschen") }}
              </b-button>
            </div>
          </template>

        </b-modal>

    </span>

</template>

<script>

    import JavaDateToDefaultDateFormat from '@/components/layout/JavaDateToDefaultDateFormat.vue'
    import bootbox from 'bootbox'
    import axios from 'axios'

    // Define a new component
    export default {
        name: 'ImageCarousel',
        components: {
          JavaDateToDefaultDateFormat
        },
        props: {

            /** Bilder die angezeigt werden sollen */
            mangel: {
                type: Object,
                required: true,
            },
            /** wenn gesetzt, dann soll dieses Bild angezeigt werden */
            showImage: {
              type: Object,
              required: false,
            }

        },
        /*
          Defines the data used by the component
        */
        data: function () {
            return {
              controls: 'controls',
              indicators: 'indicators',
              images: null,
              /** Bild in Detailansicht */
              image: null,
            }
        },
        watch: {
          mangel: {
            handler: function (newObj) {
              console.log('Mangel geändert oder neues Bild ' + newObj)
              this.setImages()
            },
            deep: true
          }
        },
        mounted: function () {
          this.init()
          this.setImages()
        },
        methods: {

          onSlideEnd: function (slide) {
            console.log('onSlideEnd', slide)
          },
          setImages: function () {

            if (this.mangel) {

              this.images = this.mangel.bilder
              if (this.images && this.images.length > 1) {

                // gehe zum letzten Slide
                this.$nextTick(() => {
                  const index = this.images.length - 1
                  console.log('got to slide', index)
                  const coursel = this.$refs.myCarousel
                  if (coursel) {
                    setTimeout(() => {
                      console.log('Waited for 1 seconds')
                      coursel.setSlide(index)
                    }, 1000);

                  } else {
                    console.log('coursel not found')
                  }
                })

              }

            }

          },
          init: function () {

            console.log('init ImageCarousel')

          },
          /** Bild in Modal anzeigen */
          showLarge: function (obj) {

            console.log('showLarge', obj)
            this.image = obj
            this.$bvModal.show('large-img')

          },
          /**
           * ein Bild löschen
           */
          deleteImage: function (obj) {

            const that = this
            const text = this.$t('message.imageCarousel_delete_sure')
            bootbox.confirm(text, function(result) {
              if (result) {

                that.showSpinner()
                const url = process.env.VUE_APP_SERVER_URL + '/datenbroker/deleteMangelBild'
                const params = {
                  id: obj.id,
                }
                axios ({
                  method:   'GET',
                  params:   params,
                  url:      url
                }).then(function () {

                  that.$emit('image-deleted', {
                    mangel: that.mangel,
                    image: obj,
                  })
                  for (let i = 0; i < that.images.length; i++) {
                    if (that.images[i].id === obj.id) {
                      that.images.splice(i, 1)
                    }
                  }
                  that.hideSpinner()
                  that.$bvModal.hide('large-img')

                }).catch(error => {
                  console.log(error)
                  alert('Es gab einen Fehler beim Löschen des Bildes. Bitte wenden Sie sich an einen Biotech Mitarbeiter.')
                })

              }
            })

          },

        }
    }

</script>

<style scoped>

    .img-fluid {
        max-height: 400px;
        min-height: 100px;
    }

</style>
